<template>
<div class=""   style="padding:0 20px;">

<div class="yo-fixed-top" style="top:132px;z-index:999;">
<div class="row el-container" style="background:#fff;padding:16px 20px;">
   <div class="col s12">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="">
         <el-breadcrumb-item>Centro</el-breadcrumb-item>
         <el-breadcrumb-item>Utente</el-breadcrumb-item>
         <el-breadcrumb-item>Modifica</el-breadcrumb-item>
      </el-breadcrumb>
   </div>
</div>
</div>

   <el-form ref="formBasic" :model="item.row" @submit.native.prevent="onSubmit" :rules="rulesForm" label-width="180px" class="label-30">

      <div class="title_h1 yo-color-primary" style="margin-top:30px;">DATI UTENTE</div>
      <div class="row pad" style="margin-top:20px;">
         <!-- 
         <div class="col s12 ">
          <el-form-item label="Ruolo" prop="ruolo">
            <el-select v-model="item.row.ruolo"  placeholder="Selezionare dalla lista" style="width:100%;" >
              <el-option label="Referente" :value="10" ></el-option>
              <el-option label="Utente" :value="1" ></el-option>
            </el-select>
          </el-form-item>
          </div> 
      -->

        <div class="col s12">
         <el-form-item label="Cognome" prop="cognome">
         <el-input  v-model="item.row.cognome"></el-input>
         </el-form-item>
         </div> 

         <div class="col s12">
         <el-form-item label="Nome" prop="nome">
         <el-input  v-model="item.row.nome"></el-input>
         </el-form-item>
         </div> 

         <div class="col s12">
         <el-form-item label="Email" prop="email">
         <el-input  v-model="item.row.email"></el-input>
         </el-form-item>
         </div> 

         <div class="col s12">
         <el-form-item label="Cellulare" prop="cellulare">
         <el-input  v-model="item.row.cellulare"></el-input>
         </el-form-item>
         </div> 
      
      </div>

    <div class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
      <div class="col s12 m3">
        <el-button style="width:100%;"  @click="$router.push('/home')">Indietro</el-button>
        </div> 
      <div class="col s12 m4 offset-m5">
        <el-button type="primary" @click="onSubmit" class="yo-bg-color-secondary" style="width:100%;border:none;">Salva</el-button>
      </div>
    </div>


  



  </el-form>



</div>
</template>

<script>
import emailContatto from './Email-contatto.vue'
import dbItem from '../teras/dbItem'

export default {
   name: 'contatto-edit',
   components: {

   },
   data() {
      return {
         loading:{}
         ,item:{}
      }
   },
   created () {
      console.log("Arrivo al contatto-edit.vue con id "+this.$route.params.id)
      this.item = new dbItem({table:'contatto'})

      this.item.load(this.$route.params.id).then((data) => {

         if(this.item.row.centro<1)
            this.item.row.centro = this.$centro.profile.row.id

         if(this.item.rowIsNew){
            this.item.row.ruolo=1
         }else{
         //mettere il nome della pagina cme modifica
         }
      })
   },
   methods: {
      onSubmit: async function() {
         this.$refs.formBasic.validate(async (valid) => {
         if (valid) {      
            this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
            this.item.row.modificatoil=this.$moment()
            await this.item.save()
            await this.$centro.init()

            if(typeof this.$route.params.id == 'undefined'){
              var html = this.$teras.renderVue(emailContatto,{contatto:this.item.row, utente:this.$teras.utente, centro:this.$centro.profile.row})
              this.$axios.email({from:'innsin@terasmm.it',oggetto:'INNSIN – Abilitazione alla compilazione delle schede INNSIN ',to:this.item.row.email,body:html}).then((data) => {
                  console.log("Email con invio credenziali inviata")
              }).catch((error) => {
                  console.log("Errore nell'invio della email con le credenziali")
                  console.log(error)
              })
            }

            this.loading.close()
            this.$router.push('/contatto/')
            
         } else {
            return false
         }
         })
      }
      ,onCancel() {
         //this.$router.go(-1)
         this.$router.push('/contatto/')
      }

  },
  computed: {
    rulesForm:function() {
      var rulesNow = {
        ruolo: [
          { required: true, message: 'Il ruolo è obbligatorio', trigger: 'blur'  }
        ],
        cognome: [
          { required: true, message: 'Il cognome è obbligatorio', trigger: 'blur'  }
        ],
        nome: [
          { required: true, message: 'Il nome è obbligatorio', trigger: 'blur' }
        ],
        cellulare: [
          { required: true, message: 'Il cellulare è obbligatorio'}
        ],
        emailchecks: [
          { required: true, message: 'L\'indirizzo email di controllo è obbligatorio'}
        ],     
        email: [
          { required: true, message: 'L\'indirizzo email è obbligatorio'},
          { type: 'email', message: 'Inserire un indirizzo email corretto', trigger: 'blur,change' }
        ]

      }
      return rulesNow
    }
  }
}
</script>
<style scoped>
.el-checkbox {
    width: 100%;
    margin: 0 !important;
}.el-form-item__label{
  width: 16.66% !important;
}.el-form-item__content{
  margin-left: 16.66% !important;

}.col.m6 .el-form-item__label{
  width: 33.32% !important;
}.col.m6 .el-form-item__content{
  margin-left: 33.32% !important;


}.col.m4 .el-form-item__label{
  width: 50% !important;
  
}.el-switch.is-checked .el-switch__core{
  background-color:#002f6d;
  border-color:#002f6d;


}.el-upload{
  display:block !important;
}.el-upload-dragger{
  height:100px !important;
  width:100% !important;
}
</style>